import { render, staticRenderFns } from "./CouponDetail.vue?vue&type=template&id=22f537f8&scoped=true&lang=pug&"
import script from "./CouponDetail.vue?vue&type=script&lang=js&"
export * from "./CouponDetail.vue?vue&type=script&lang=js&"
import style0 from "./CouponDetail.vue?vue&type=style&index=0&id=22f537f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f537f8",
  null
  
)

export default component.exports